function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("tspan", {
  x: 110,
  y: 23.49
}, "PRAWY");
var _ref2 = /*#__PURE__*/React.createElement("tspan", {
  x: 110,
  y: 39.49
}, "PRZYCISK MYSZY");
var _ref3 = /*#__PURE__*/React.createElement("tspan", {
  x: 110,
  y: 54.935
}, "KLIKAJ\u0104C NA ELEMENT");
var _ref4 = /*#__PURE__*/React.createElement("tspan", {
  x: 110,
  y: 66.935
}, "PPM OTWORZYSZ MENU");
var _ref5 = /*#__PURE__*/React.createElement("tspan", {
  x: 378,
  y: 25.49
}, "SKR\xD3TY KLAWISZOWE");
var _ref6 = /*#__PURE__*/React.createElement("tspan", {
  x: 378,
  y: 42.935
}, "STRZA\u0141KI POS\u0141U\u017B\u0104 CI DO DELIKATNEGO");
var _ref7 = /*#__PURE__*/React.createElement("tspan", {
  x: 378,
  y: 54.935
}, "PRZESUWANIA ELEMENT\xD3W W KA\u017BD\u0104");
var _ref8 = /*#__PURE__*/React.createElement("tspan", {
  x: 378,
  y: 66.935
}, "ZE STRON. PE\u0141NA DOWOLNO\u015A\u0106!");
var _ref9 = /*#__PURE__*/React.createElement("tspan", {
  x: 719,
  y: 26.935
}, "COFNIJ ZMIANY");
var _ref10 = /*#__PURE__*/React.createElement("tspan", {
  x: 658,
  y: 59.935
}, "USU\u0143 WYBRANY ELEMENT");
var _ref11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_571_62)"
}, React.createElement("path", {
  d: "M47 12.2414C47 11.0859 47 10.5082 47.157 10.0421C47.4564 9.15374 48.1537 8.45636 49.0421 8.15704C49.5082 8 50.0859 8 51.2414 8V8C61.2554 8 66.2625 8 70.3018 9.36102C78.0009 11.9551 84.0449 17.9991 86.639 25.6982C88 29.7375 88 34.7446 88 44.7586V58.3226C88 62.7236 88 64.9242 86.7101 66.3519C86.5968 66.4773 86.4773 66.5968 86.3519 66.7101C84.9242 68 82.7236 68 78.3226 68H57C52.286 68 49.9289 68 48.4645 66.5355C47 65.0711 47 62.714 47 58V12.2414Z",
  fill: "#606060"
}));
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M41 12.2414C41 11.0859 41 10.5082 40.843 10.0421C40.5436 9.15374 39.8463 8.45636 38.9579 8.15704C38.4918 8 37.9141 8 36.7586 8V8C26.7446 8 21.7375 8 17.6982 9.36102C9.99906 11.9551 3.95515 17.9991 1.36102 25.6982C0 29.7375 0 34.7446 0 44.7586V58.3226C0 62.7236 0 64.9242 1.28993 66.3519C1.40319 66.4773 1.52272 66.5968 1.64808 66.7101C3.07583 68 5.27636 68 9.67742 68H31C35.714 68 38.0711 68 39.5355 66.5355C41 65.0711 41 62.714 41 58V12.2414Z",
  fill: "#606060",
  fillOpacity: 0.25
});
var _ref13 = /*#__PURE__*/React.createElement("rect", {
  y: 73,
  width: 88,
  height: 25,
  rx: 5,
  fill: "url(#paint0_linear_571_62)"
});
var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 276,
  y: 44,
  width: 23,
  height: 23,
  rx: 5,
  fill: "#606060"
});
var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 301,
  y: 44,
  width: 23,
  height: 23,
  rx: 5,
  fill: "#606060"
});
var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 326,
  y: 44,
  width: 23,
  height: 23,
  rx: 5,
  fill: "#606060"
});
var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 624,
  y: 44,
  width: 23,
  height: 23,
  rx: 5,
  fill: "#606060"
});
var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 684,
  y: 11,
  width: 23,
  height: 23,
  rx: 5,
  fill: "#606060"
});
var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 624,
  y: 11,
  width: 39,
  height: 23,
  rx: 5,
  fill: "#606060"
});
var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 301,
  y: 19,
  width: 23,
  height: 23,
  rx: 5,
  fill: "#606060"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M314.925 30.8981L313.136 29.1377L313.111 34.3909C313.111 34.4712 313.094 34.5507 313.062 34.6248C313.03 34.6989 312.984 34.7662 312.925 34.8227C312.867 34.8793 312.797 34.9241 312.721 34.9545C312.644 34.9849 312.562 35.0004 312.48 35V35C312.397 34.9996 312.315 34.9834 312.239 34.9523C312.163 34.9212 312.094 34.8758 312.036 34.8187C311.978 34.7617 311.932 34.694 311.9 34.6196C311.869 34.5452 311.853 34.4656 311.854 34.3852L311.878 29.1332L310.072 30.8701C310.013 30.9268 309.944 30.9716 309.867 31.0021C309.791 31.0326 309.709 31.0481 309.626 31.0478C309.544 31.0474 309.462 31.0313 309.386 31.0002C309.309 30.9692 309.24 30.9238 309.182 30.8667V30.8667C309.065 30.7513 308.999 30.5954 309 30.4331C309.001 30.2708 309.068 30.1154 309.186 30.0011L312.151 27.1442C312.249 27.0508 312.381 26.9989 312.518 27C312.655 27.0011 312.785 27.055 312.881 27.15L315.818 30.0371C315.935 30.1524 316.001 30.3082 316 30.4704C315.999 30.6326 315.932 30.7879 315.814 30.9021C315.695 31.0163 315.535 31.0799 315.368 31.0792C315.202 31.0784 315.042 31.0133 314.925 30.8981V30.8981Z",
  fill: "#ADADAD"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M310.075 56.1019L311.864 57.8623L311.889 52.6091C311.889 52.5288 311.906 52.4493 311.938 52.3752C311.97 52.3011 312.016 52.2338 312.075 52.1773C312.133 52.1207 312.203 52.0759 312.279 52.0455C312.356 52.0151 312.438 51.9996 312.52 52V52C312.603 52.0004 312.685 52.0166 312.761 52.0477C312.837 52.0788 312.906 52.1242 312.964 52.1813C313.022 52.2383 313.068 52.306 313.1 52.3804C313.131 52.4548 313.147 52.5344 313.146 52.6148L313.122 57.8668L314.928 56.1299C314.987 56.0732 315.056 56.0284 315.133 55.9979C315.209 55.9674 315.291 55.9519 315.374 55.9522C315.456 55.9526 315.538 55.9687 315.614 55.9998C315.691 56.0308 315.76 56.0762 315.818 56.1333V56.1333C315.935 56.2487 316.001 56.4046 316 56.5669C315.999 56.7292 315.932 56.8846 315.814 56.9989L312.849 59.8558C312.751 59.9492 312.619 60.0011 312.482 60C312.345 59.9989 312.215 59.945 312.119 59.85L309.182 56.9629C309.065 56.8476 308.999 56.6918 309 56.5296C309.001 56.3674 309.068 56.2121 309.186 56.0979C309.305 55.9837 309.465 55.9201 309.632 55.9208C309.798 55.9216 309.958 55.9867 310.075 56.1019V56.1019Z",
  fill: "#ADADAD"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.102 57.9247L338.862 56.1358L333.609 56.1111C333.529 56.1108 333.449 56.0942 333.375 56.0623C333.301 56.0304 333.234 55.9838 333.177 55.9252C333.121 55.8666 333.076 55.797 333.046 55.7206C333.015 55.6442 333 55.5623 333 55.4798V55.4798C333 55.3972 333.017 55.3154 333.048 55.2393C333.079 55.1631 333.124 55.094 333.181 55.0358C333.238 54.9777 333.306 54.9317 333.38 54.9005C333.455 54.8692 333.534 54.8533 333.615 54.8537L338.867 54.8784L337.13 53.0718C337.073 53.0132 337.028 52.9436 336.998 52.8672C336.967 52.7907 336.952 52.7088 336.952 52.6262C336.953 52.5436 336.969 52.4618 337 52.3856C337.031 52.3094 337.076 52.2402 337.133 52.1821V52.1821C337.249 52.0647 337.405 51.9992 337.567 52C337.729 52.0008 337.885 52.0677 337.999 52.1862L340.856 55.1515C340.949 55.249 341.001 55.3808 341 55.5177C340.999 55.6546 340.945 55.7854 340.85 55.8815L337.963 58.818C337.848 58.9353 337.692 59.0008 337.53 59C337.367 58.9992 337.212 58.9323 337.098 58.8139C336.984 58.6954 336.92 58.5352 336.921 58.3684C336.922 58.2017 336.987 58.0421 337.102 57.9247V57.9247Z",
  fill: "#ADADAD"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M286.898 53.0753L285.138 54.8642L290.391 54.8889C290.471 54.8892 290.551 54.9058 290.625 54.9377C290.699 54.9696 290.766 55.0162 290.823 55.0748C290.879 55.1334 290.924 55.203 290.954 55.2794C290.985 55.3558 291 55.4377 291 55.5202V55.5202C291 55.6028 290.983 55.6846 290.952 55.7607C290.921 55.8369 290.876 55.906 290.819 55.9642C290.762 56.0223 290.694 56.0683 290.62 56.0995C290.545 56.1308 290.466 56.1467 290.385 56.1463L285.133 56.1216L286.87 57.9282C286.927 57.9868 286.972 58.0564 287.002 58.1328C287.033 58.2093 287.048 58.2912 287.048 58.3738C287.047 58.4564 287.031 58.5382 287 58.6144C286.969 58.6906 286.924 58.7598 286.867 58.8179V58.8179C286.751 58.9353 286.595 59.0008 286.433 59C286.271 58.9992 286.115 58.9323 286.001 58.8138L283.144 55.8485C283.051 55.751 282.999 55.6192 283 55.4823C283.001 55.3454 283.055 55.2146 283.15 55.1185L286.037 52.182C286.152 52.0647 286.308 51.9992 286.47 52C286.633 52.0008 286.788 52.0677 286.902 52.1861C287.016 52.3046 287.08 52.4648 287.079 52.6316C287.078 52.7983 287.013 52.9579 286.898 53.0753V53.0753Z",
  fill: "#ADADAD"
});
var _ref25 = /*#__PURE__*/React.createElement("tspan", {
  x: 631,
  y: 25.57
}, "CTRL");
var _ref26 = /*#__PURE__*/React.createElement("tspan", {
  x: 692,
  y: 25.57
}, "Z");
var _ref27 = /*#__PURE__*/React.createElement("tspan", {
  x: 669,
  y: 28.22
}, "+");
var _ref28 = /*#__PURE__*/React.createElement("tspan", {
  x: 627,
  y: 58.84
}, "DEL");
var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 44,
  cy: 38,
  rx: 6,
  ry: 12,
  fill: "#ADADAD"
});
var _ref30 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d_571_62",
  x: 39.3,
  y: 0.3,
  width: 56.4,
  height: 75.4,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 3.85
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0.5 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_571_62"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_571_62",
  result: "shape"
})), React.createElement("linearGradient", {
  id: "paint0_linear_571_62",
  x1: 44,
  y1: 98,
  x2: 44,
  y2: 73,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#606060",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#606060",
  stopOpacity: 0.25
})));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 801,
    height: 98,
    viewBox: "0 0 801 98",
    fill: "none"
  }, props), React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref, _ref2), React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 9.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref3, _ref4), React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref5), React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 9.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref6, _ref7, _ref8), React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 9.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref9), React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 9.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref10), _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref25), React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref26), React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 14,
    letterSpacing: "0em"
  }, _ref27), React.createElement("text", {
    fill: "#ADADAD",
    xmlSpace: "preserve",
    style: {
      "whiteSpace": "pre"
    },
    fontFamily: "Sora",
    fontSize: 8,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _ref28), _ref29, _ref30);
};
export default __webpack_public_path__ + "static/media/keyboard_shortcuts.0ffeb3d8.svg";
export { SvgComponent as ReactComponent };